// Inspired from https://github.com/a8m/angular-filter/blob/master/src/_filter/string/truncate.js

import {Pipe, PipeTransform} from '@angular/core';
import {isString} from '../utils/utils';

@Pipe({
    name: 'modificarMensaje'
})
export class ModificarMensajePipe implements PipeTransform {

    transform(input: any): any {


        if (!isString(input)) {
            return input;
        }

        let posIni = input.indexOf("<description>");
        if (posIni != -1) {
            input = input.substring(posIni + 13, input.indexOf("</description>"));
        }
        return input;
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/pipes/string/modificarMensaje.pipe.ts